import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import './styles/global.css';

const container = document.getElementById('root');
if (!container) throw new Error('No #root element — check index.html.');

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
